export default __webpack_public_path__ + "226ebc25b8e7a21d1b1d798f2c8b3f0d.png";